import {css} from '@emotion/css';

import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  container: css`
    label: articleDialogWithCta;
    position: sticky;
    top: 0;
    text-align: center;
    padding: ${spacing.XS};
    ${mq(Breakpoints.DESKTOP)} {
      padding: ${spacing.M} 0 ${spacing.L};
    }
  `,
  dialogue: css`
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  `,
  icon: css`
    label: articleDialogWithCta__icon;
    margin: ${spacing.XS} 0;
  `,
  header: css`
    label: articleDialogWithCta__header;
    color: ${colours.font.INFORMATION};
  `,
  paragraph: css`
    label: articleDialogWithCta__paragraph;
    /* @todo: remove !important when updating the Paragraph component to @emotioncss */
    color: ${colours.font.ASSISTIVE} !important;
    text-align: center !important;
  `,
  button: css`
    label: articleDialogWithCta__button;
    display: block;
    width: 100%;
  `,
  trustpilot: css`
    label: articleDialogWithCta__trustpilot;
    margin-top: ${spacing.XS};
    overflow-x: hidden;
  `,
  trustpilotWidget: css`
    label: articleDialogWithCta__trustpilotWidget;
    ${mq(Breakpoints.TABLET)} {
      width: calc(100% + 1.3333rem);
    }
  `,
};

export default styles;
